import React from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Button from '../../composants/Button/Button';
import EchangesList from '../../composants/EchangesList/EchangesList';
import './FicheContact.css';

interface Commande {
  nom: string;
  montant: number;
}

interface ContactDetails {
  organisme: string;
  nom: string;
  email: string;
  telephone: string;
  commandes: Commande[];
  notes: Note[];
  echanges?: Echange[]; // Add this
}

interface Note {
  texte: string;
  date: string;
  auteur: string;
}

const FicheContact: React.FC = () => {
  const { id } = useParams();
  const contactDetails: ContactDetails = {
    organisme: "Ile de France",
    nom: "Marc Kerfite",
    email: "marc.kerfite@iledefrance.fr",
    telephone: "06 85 39 29 20",
    commandes: [
      { nom: "Nom de la commande 1", montant: 3000 },
      { nom: "Nom de la commande 2", montant: 10000 }
    ],
    notes: [
      {
        texte: "Commande \"Nom de la commande\" créer par le client.",
        date: "25/04/2025 à 14h07",
        auteur: "Michel Lapirate"
      }
    ]
  };

  // Add mockEchanges data
  const mockEchanges = [
    {
      id: '1',
      auteur: 'Michel Lapirate',
      date: '25/04/2025',
      heure: '14h07',
      message: 'Commande "Nom de la commande" créer par le client.',
    },
    {
      id: '2',
      auteur: 'Marc Kerfite',
      date: '25/04/2025',
      heure: '15h30',
      message: 'Validation de la commande en cours.',
    }
  ];

  const navigate = useNavigate();
  return (
    <>
      <button
        className="back-button"
        onClick={() => navigate(-1)}
        aria-label="Retour"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55" fill="none">
          <circle cx="27.5" cy="27.5" r="27.5" fill="#2C3948" />
          <path d="M34.7369 13.0263L20.2632 27.5L34.7369 41.9737" stroke="#FFFDFC" stroke-width="4" stroke-linecap="round" />
        </svg>
      </button>
      <div className="fiche-contact">
        <h1>{contactDetails.nom}</h1>
        <div className="details-client-fiche">
          <h2>Détails du client</h2>
          <hr className='darkblue' />
          <div className="client-info">
            <div className="info-container">
              <p><strong>Organisme:</strong> {contactDetails.organisme}</p>
              <p><strong>Nom du contact:</strong> {contactDetails.nom}</p>
              <p><strong>Email:</strong> {contactDetails.email}</p>
              <p><strong>N° de téléphone:</strong> {contactDetails.telephone}</p>
            </div>
          </div>
        </div>

        <div className="historique-commandes">
          <h2>Historique des commandes</h2>
          <hr className='darkblue' />
          <div className="commandes-list">
            {contactDetails.commandes.map((commande, index) => (
              <div key={index} className="commande-item">
                <span className="commande-nom">{commande.nom}</span>
                <span className="commande-montant">{commande.montant}€</span>
                <Button
                  value="Voir la commande"
                  variant="third"
                  size="small"
                  onClick={() => navigate(`/commande-ms/${index}`)}
                />
              </div>
            ))}
          </div>
          <div className="total-commandes">
            <p>Nombre total de commande: {contactDetails.commandes.length}</p>
          </div>
        </div>

        <div className="notes-section">
          <EchangesList
            titre="Notes"
            echanges={mockEchanges}
            onAddEchange={(message) => {
              console.log('New message:', message);
              // Handle adding new exchange
            }}
          />
        </div>

      </div>
    </>
  );
};

export default FicheContact;